import React from 'react';
import {
  Paper,
  Typography,
  TextField,
  MenuItem
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Exclamation } from 'assets/icons';

export function NoOptionsMessage(props) {
  const { selectProps, innerProps, children } = props;
  return (
    <Typography
      color="textSecondary"
      data-id="noOptionsMessage"
      className={selectProps.classes.noOptionsMessage}
      {...innerProps}
    >
      {children}
    </Typography>
  );
}

NoOptionsMessage.propTypes = {
  children: PropTypes.node
};

NoOptionsMessage.defaultProps = {
  children: []
};


export function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

inputComponent.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};

inputComponent.defaultProps = {
  inputRef: null
};

export function Control(props) {
  const {
    children,
    innerProps,
    innerRef,
    selectProps: {
      name, classes, TextFieldProps, isValid, title
    }
  } = props;
  return (
    <TextField
      fullWidth
      variant="outlined"
      error={!isValid}
      InputProps={{
        inputComponent,
        name,
        endAdornment: !isValid && (
          <Exclamation />
        ),
        inputProps: {
          title: `${title}`,
          className: classes.input,
          "data-id": {name},
          ref: innerRef,
          children,
          ...innerProps
        }
      }}
      {...TextFieldProps}
    />
  );
}

Control.propTypes = {
  children: PropTypes.node,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
Control.defaultProps = {
  children: [],
  innerRef: null
};

export function Option(props) {
  const {
    innerRef, isFocused, isSelected, innerProps, children
  } = props;
  return (
    <MenuItem
      ref={innerRef}
      selected={isFocused}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400
      }}
      {...innerProps}
    >
      {children}
    </MenuItem>
  );
}

Option.propTypes = {
  children: PropTypes.node,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool
};

Option.defaultProps = {
  children: [],
  innerRef: null,
  isFocused: false,
  isSelected: false
};

export function Placeholder(props) {
  const {
    selectProps, innerProps, children
  } = props;
  return (
    <Typography
      color="textSecondary"
      data-id="placeholder"
      className={selectProps.classes.placeholder}
      {...innerProps}
    >
      {children}
    </Typography>
  );
}

Placeholder.propTypes = {
  children: PropTypes.node
};

Placeholder.defaultProps = {
  children: []
};


export function ValueContainer(props) {
  const {
    selectProps, children
  } = props;
  return <div className={selectProps.classes.valueContainer}>{children}</div>;
}

ValueContainer.propTypes = {
  children: PropTypes.node
};

ValueContainer.defaultProps = {
  children: []
};


export function Menu(props) {
  const {
    selectProps, innerProps, children
  } = props;
  return (
    <Paper square className={selectProps.classes.paper} {...innerProps}>
      {children}
    </Paper>
  );
}

Menu.propTypes = {
  children: PropTypes.node
};

Menu.defaultProps = {
  children: []
};
